/* eslint-disable prettier/prettier */
import { useEffect, useState } from 'react';

import {
	userService,
	AdminActionCenter,
	AdminRecentActivityResponse,
} from '../services/userService';

export function useAdminActionCenter(page = 1, limit = 20) {
	/* ================= ACTION CENTER ================= */

	const [data, setData] = useState<AdminActionCenter | null>(null);

	const [loading, setLoading] = useState(false);

	const [error, setError] = useState<string | null>(null);

	const fetchActionCenter = async () => {
		try {
			setLoading(true);
			setError(null);

			const response = await userService.getAdminActionCenter();

			setData(response);
		} catch (err: any) {
			setError(err.message || 'Failed to fetch action center');
		} finally {
			setLoading(false);
		}
	};

	/* ================= RECENT ACTIVITY ================= */

	const [recentActivityData, setRecentActivityData] =
		useState<AdminRecentActivityResponse | null>(null);

	const [recentActivityLoading, setRecentActivityLoading] = useState(false);

	const [recentActivityError, setRecentActivityError] = useState<
		string | null
	>(null);

	const fetchRecentActivity = async () => {
		try {
			setRecentActivityLoading(true);
			setRecentActivityError(null);

			const response = await userService.getAdminRecentActivity(
				page,
				limit
			);

			setRecentActivityData(response);
		} catch (err: any) {
			setRecentActivityError(
				err.message || 'Failed to fetch recent activity'
			);
		} finally {
			setRecentActivityLoading(false);
		}
	};

	/* ================= USE EFFECT ================= */

	useEffect(() => {
		fetchActionCenter();
		fetchRecentActivity();
	}, [page, limit]);

	return {
		/* Action Center */
		data,
		loading,
		error,
		refetch: fetchActionCenter,

		/* Recent Activity */
		recentActivityData,
		recentActivityLoading,
		recentActivityError,
		refetchRecentActivity: fetchRecentActivity,
	};
}
